import { KuposErrorSuccessModal, KuposModalWithButtons } from '../../../common';
import React, { Component, useEffect, useState } from 'react';

// import ApiUrls from '../../../services/apiUrls';
import CommonService from '../../../../services/commonService';
import PropTypes from 'prop-types';
import RutInput from './components/RutInput';
import ApiUrls from '../../../../services/apiUrls';


function RechargeWalletKuposPayTransfer(props) {
  let refs = null;
  const [selectedView, setSelectedView] = useState('rut');
  const [favourites, setFavourites] = useState(props.profileData.favourites);
  const [favAdd, setFavAdd] = useState([]);
  const [favRemove, setFavRemove] = useState([]);
  const [amountError, setAmountError] = useState(null);
  const [recipient, setRecipient] = useState(null);

  const [amount, setAmount] = useState(null);
  const [rut, setRut] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(null);
  const [responseSuccess, setResponseSuccess] = useState(null);
  const [rutError, setRutError] = useState(null);
  const [modalBody1, setModalBody1] = useState(null);
  const [modalBody2, setModalBody2] = useState(null);
  const [modalTitle, setModalTitle] = useState(null);
  const [showModal, setShowModal] = useState(null);
  const [onModalButtonClick, setOnModalButtonClick] = useState(null);
  const [modalButton1Text, setModalButton1Text] = useState(null);
  const [modalButton2Text, setModalButton2Text] = useState(null);
  const [showConfirmAmountBody, setShowConfirmAmountBody] = useState(null);
  const [showTransferSuccessBody, setShowTransferSuccessBody] = useState(null);
  const [showTransferFailBody, setShowTransferFailBody] = useState(null);

  const getProfile = () => {
    props.actions.getProfile({ url: ApiUrls.profile() }).then(
      res => {
        props.actions.setLoginData(res);

        setFavourites(res.favourites);
      },
      err => {},
    );
  };

  useEffect(() => {
    getProfile();

    return () => {
      let body = {
        add: favAdd,
        remove: favRemove,
      };
      props.actions.updateFavourites({ url: ApiUrls.favourites(), data: body });
    };
  }, []);

  const isValid = () => {
    let errorCount = 0;

    if (!rut) {
      // this.setState({
      //   rutError: {
      //     message: 'VALIDATIONS.VALID_RUT',
      //   },
      // });
      setRutError({
        message: 'VALIDATIONS.VALID_RUT',
      });
      errorCount++;
    } else if (!CommonService.isRutValid(rut)) {
      // this.setState({
      //   rutError: {
      //     message: 'VALIDATIONS.VALID_RUT_VALID',
      //   },
      // });
      setRutError({
        message: 'VALIDATIONS.VALID_RUT_VALID',
      });
      errorCount++;
    }
    if (errorCount <= 0) {
      return true;
    }
    return false;
  };

  const getCustomerInfo = () => {
    onBlur(rut);
    if (!isValid()) {
      return;
    }
    let queryParams='';
    if (CommonService.shouldPassOperatorId(props.operator)) {
      queryParams ='&operator_id='+ CommonService.getOperatorId(props.operator)
    }
    setTimeout(() => {
      props.actions.getCustomerInfo({ url: ApiUrls.customerInfo(rut , queryParams) }).then(onResponse, err => {});
    }, 200);
  };

  const onResponse = result => {
    console.log(result);
    if (result && !result.recipient_id) {
      if (result.status == 404) {
        // this.setState({
        //   rutError: {
        //     message: result.message,
        //   },
        // });
        setRutError({
          message: result.message,
        });
      } else {
        // this.setState({
        //   showSuccessModal: true,
        //   responseSuccess: false,
        //   modalTitle: this.props.t('HOME.WE_ARE_SORRY'),
        //   modalBody1:
        //     'Puede que el RUT que ingresaste esté erróneo o no esté registrado en PasajeBus.com',
        //   modalBody2: 'Las transferencias de saldo solo son posibles entre cuentas registradas.',
        // });
        setShowSuccessModal(true);
        setResponseSuccess(false);
        setModalTitle(props.t('HOME.WE_ARE_SORRY'));
        setModalBody1(
          'Puede que el RUT que ingresaste esté erróneo o no esté registrado en PasajeBus.com',
        );
        setModalBody2('Las transferencias de saldo solo son posibles entre cuentas registradas.');
      }

      return;
    } else if (result && result.recipient_id) {
      // this.setState({
      //   recipient: result,
      // });
      setRecipient(result);
    }
  };
  const onBlur = text => {
    if (!text) {
      // this.setState({
      //   rutError: {
      //     message: 'VALIDATIONS.VALID_RUT',
      //   },
      // });
      setRutError({
        message: 'VALIDATIONS.VALID_RUT',
      });
    } else {
      let rut = CommonService.formatRut(text);
      // this.setState({
      //   rut: rut,
      // });
      setRut(rut);
      if (!CommonService.isRutValid(rut)) {
        // this.setState({
        //   rutError: {
        //     message: 'VALIDATIONS.VALID_DOCUMENT_NUMBER',
        //   },
        // });
        setRutError({
          message: 'VALIDATIONS.VALID_DOCUMENT_NUMBER',
        });
      }
    }
  };

  const onSubmitAmount = val => {
    // if (!this.state.amount) {
    //   return;
    // }

    // this.setState({amount: })

    // console.log('Amount is', amount);
    // console.log('Wallet Bal is', props.profileData.wallet_moneys);
    let wallet_moneys =  props.profileData.wallet_moneys &&  props.profileData.wallet_moneys.amount ? props.profileData.wallet_moneys.amount : 0;

    // return

    if (Number(amount) === 0) {
      // this.setState({
      //   amountError: {
      //     message: 'TRANSLATIONS.VALID_AMOUNT',
      //   },
      // });
      setAmountError({
        message: 'TRANSLATIONS.VALID_AMOUNT',
      });
      return;
    }

    if (
      +amount >
      +wallet_moneys.amount
        // .split('.')
        // .join('')
        // .split(' ')[1]
    ) {
      // this.setState({
      //   amountError: {
      //     message: 'PROFILE.INSUFFICENT_BALANCE',
      //   },
      // });
      setAmountError({
        message: 'PROFILE.INSUFFICENT_BALANCE',
      });
      return;
    }

    if (!amount) {
      setAmountError({
        message: 'VALIDATIONS.TRANSFER_AMOUNT',
      });
    } else {
      setShowModal(true);
      setModalTitle(props.t('PROFILE.SHARE_BAL_WARNING'));
      // setOnModalButtonClick(transferAmount);
      setModalButton1Text(props.t('PROFILE.YES_SHARE'));
      setModalButton2Text(props.t('PROFILE.YES_GO_BACK'));
      setShowConfirmAmountBody(true);
    }

    // !amount
    //   ? setAmountError({
    //       message: 'VALIDATIONS.TRANSFER_AMOUNT',
    //     })
    //   : this.setState({
    //       showModal: true,
    //       modalTitle: this.props.t('PROFILE.SHARE_BAL_WARNING'),
    //       onModalButtonCLick: this.transferAmount,
    //       modalButton1Text: this.props.t('PROFILE.YES_SHARE'),
    //       modalButton2Text: this.props.t('PROFILE.YES_GO_BACK'),
    //       showConfirmAmountBody: true,
    //     });
  };

  const transferAmount = () => {
    let body = {
      recipient_id: recipient.recipient_id,
      recipient_identity_val: recipient.recipient_identity_val,
      recipient_email: recipient.recipient_email,
      transfer_amount: amount,
      operator_id: props.operator && props.operator.operator_id ? props.operator.operator_id : null
    };
    props.actions
      .transferMoney({
        url: ApiUrls.transferMoney(),
        data: body,
      })
      .then(
        result => onTransferMoneyResponse(result),
        err => {},
      );

    setRut('');
  };

  const updateProfile = () => {
    // this.setState({ rutError: null });
    setRutError(null);
    props.actions.getProfile({ url: ApiUrls.profile() }).then(
      res => {
        if (res && res.error) {
          return;
        } else if (res && res.auth_token) {
          CommonService.storeLoginDetails(res, props.actions.setLoginData);
        }
      },
      err => {},
    );
  };

  const onTransferMoneyResponse = result => {
    if (!result.status) {
      // this.setState({
      //   recipient: null,
      //   amount: null,
      //   rut: null,
      //   showModal: false,
      //   modalTitle: null,
      //   showSuccessModal: true,
      //   responseSuccess: true,
      //   modalBody1: 'PROFILE.TRANSFER_SUCCESS',
      //   modalBody2: 'PROFILE.TRANSFER_SUCCESS_EMAIL',
      // });
      setRecipient(null);
      setAmount(null);
      setRut(null);
      setShowModal(false);
      setModalTitle(null);
      setShowSuccessModal(true);
      setResponseSuccess(true);
      setModalBody1('PROFILE.TRANSFER_SUCCESS');
      setModalBody2('PROFILE.TRANSFER_SUCCESS_EMAIL');
      updateProfile();
    } else {
      // this.setState({
      //   showModal: false,
      //   modalTitle: null,
      //   showSuccessModal: true,
      //   responseSuccess: false,
      //   modalBody1: 'Tu transacción no pudo ser realizada. Por favor intenta nuevamente.',
      //   modalBody2: '¿Necesitas ayuda? ayuda@pasajebus.com +56 9 4915 6683.',
      // });
      setShowModal(false);
      setModalTitle(null);
      setShowSuccessModal(true);
      setResponseSuccess(false);
      setModalBody1('Tu transacción no pudo ser realizada. Por favor intenta nuevamente.');
      setModalBody2('¿Necesitas ayuda? ayuda@pasajebus.com +56 9 4915 6683.');
    }
  };

  const onAmountChange = val => {
    if (CommonService.onlyNumericValues(val)) {
      // this.setState({ amount: CommonService.onlyNumbers(val), amountError: null });
      setAmount(CommonService.onlyNumbers(val));
      setAmountError(null);
    } else {
      // this.setState({
      //   amountError: {
      //     message: 'VALIDATIONS.TRANSFER_AMOUNT',
      //   },
      //   amount: CommonService.onlyNumbers(val),
      // });
      setAmountError({
        message: 'VALIDATIONS.TRANSFER_AMOUNT',
      });
      setAmount(CommonService.onlyNumbers(val));
    }
    // this.setState({rechargeAmount:val})
  };

  const isFavourite = () => {
    if (favourites) {
      return favourites.find(it => {
        return recipient.recipient_id == it.id;
      });
    }
    return null;
  };

  const addRemoveFavourite = cust => {
    let isFav = favourites.find(it => {
      return it.identity_val == cust.recipient_identity_val;
    });
    let isFavList = favRemove.find(it => {
      return it == cust.recipient_id;
    });
    if (isFavList) {
      let favRemoveTemp = favRemove.filter(it => {
        return it != cust.recipient_id;
      });
      // this.setState({
      //   favRemove: favRemove,
      // });
      setFavRemove(favRemoveTemp);
    }
    let isFavListAdd = favAdd.find(it => {
      return it == cust.recipient_id;
    });
    if (isFavListAdd) {
      let favAddTemp = favAdd.filter(it => {
        return it != cust.recipient_id;
      });
      // this.setState({
      //   favAdd: favAdd,
      // });
      setFavAdd(favAddTemp);
    }
    if (!isFav) {
      if (favourites.length > 5) {
        refs.toast.show('Máximo 5 favoritos permitidos por cuenta.');
        return;
      }
      let favAddTemp = CommonService.copyObject(favAdd);
      favAddTemp.push(cust.recipient_id);
      let favouritesTemp = CommonService.copyObject(favourites);
      favouritesTemp.push({
        id: cust.recipient_id,
        name: cust.recipient_name,
        email: cust.recipient_email,
        identity_val: cust.recipient_identity_val,
      });
      // this.setState({
      //   favourites: favourites,
      //   favAdd: favAdd,
      // });
      setFavourites(favouritesTemp);
      setFavAdd(favAddTemp);
    } else {
      let favRemoveTemp = CommonService.copyObject(favRemove);
      favRemoveTemp.push(cust.recipient_id);
      let favouritesTemp = favourites.filter(it => {
        return it.identity_val != cust.recipient_identity_val;
      });
      // this.setState({
      //   favourites: favourites,
      //   favRemove: favRemove,
      // });
      setFavourites(favouritesTemp);
      setFavRemove(favRemoveTemp);
    }
  };

  const addRemoveFavouriteList = cust => {
    if (isFavouriteList(cust)) {
      // this.state.favAdd.push(cust.id);
      let favRemoveTemp = favRemove.filter(it => {
        return it != cust.id;
      });
      // this.setState({
      //   favRemove: favRemove,
      // });
      setFavRemove(favRemoveTemp);
    } else {
      let favRemoveTemp = CommonService.copyObject(favRemove);
      favRemoveTemp.push(cust.id);

      // this.setState({
      //   favRemove: favRemove,
      // });
      setFavRemove(favRemoveTemp);
    }
  };

  const isFavouriteList = fav => {
    if (favourites) {
      return favRemove.find(it => {
        return fav.id == it;
      });
    }
    return null;
  };

  const selectfav = fav => {
    let customerInfo = {};
    customerInfo.recipient_id = fav.id;
    customerInfo.recipient_name = fav.name;
    customerInfo.recipient_email = fav.email;
    customerInfo.recipient_identity_val = fav.identity_val;
    // this.setState({
    //   recipient: customerInfo,
    //   rut: fav.identity_val,
    //   rutError: null,
    // });
    setRecipient(customerInfo);
    setRut(fav.identity_val);
    setRutError(null);
    setTimeout(() => {
      // this.setState({
      //   rutError: null,
      // });
      setRutError(null);
    }, 200);
  };

  const { t } = props;
  return (
    <div
      id="sub-body-my-account"
      className="my-account-recharge-wallet-kupospay-recharge transfer-money"
    >
      <div className="my-account-recharge-wallet-kupospay-recharge-inner">
        <div className="white-triangle share-balance"></div>

        {recipient ? (
          <div
            className="pointer"
            onClick={() => {
              // this.setState({ recipient: null, rut: null });
              setRecipient(null);
              setRut(null);
            }}
          >
            <img style={{ height: 17, width: 'auto' }} src="/static/images/back_arrow_bip.png" alt="" />
          </div>
        ) : null}
        <div className="my-account-title center-text">
          <div className="sub-section-account-general-title font13">
            {t('PROFILE.SHARE_MONEY_HEADING.NORMAL')}{' '}
            <span className="bold-text">{t('PROFILE.SHARE_MONEY_HEADING.BOLD')}</span>
          </div>
          <div className="sub-section-account-general-description font11">
            <span>{t('PROFILE.SHARE_MONEY_DESCRIPTION')}</span>
          </div>
        </div>
        <div className="recharge-transfer-body">
          {selectedView == 'rut' ? (
            <RutInput
              t={t}
              setRut={setRut}
              rutError={rutError}
              setRutError={setRutError}
              recipient={recipient}
              amountError={amountError}
              rut={rut}
              data={props.data}
              selectfav={selectfav}
              onSubmitAmount={onSubmitAmount}
              favourites={favourites}
              onBlur={onBlur}
              amount={amount}
              getCustomerInfo={getCustomerInfo}
              setRecipient={setRecipient}
              addRemoveFavourite={addRemoveFavourite}
              isFavourite={isFavourite}
              onAmountChange={onAmountChange}
              isFavouriteList={isFavouriteList}
              addRemoveFavouriteList={addRemoveFavouriteList}
              operator={props.operator}
            />
          ) : null}
        </div>
      </div>
      <KuposErrorSuccessModal
        showModal={showSuccessModal}
        title={modalTitle}
        success={responseSuccess}
        subTitle={modalBody1}
        t={t}
        bodyText={modalBody2}
        onButtonClick={() => setShowSuccessModal(false)}
        operator={props.operator}
      />
      <KuposModalWithButtons
        showModal={showModal}
        onHide={() => setShowModal(false)}
        title={modalTitle}
        showButton1={true}
        showButton2={true}
        buttonText1={
          props.data.transferMoneyPending ? <div className="loader-cricle"></div> : modalButton1Text
        }
        buttonText2={modalButton2Text}
        onButtonClick1={transferAmount}
        onButtonClick2={() => setShowModal(false)}
      >
        {console.log('props.data.transferMoneyPending 3', props)}
        {showConfirmAmountBody ? (
          <div className="transfer-money-modal-body font10" style={{width:350}}>
            <div className="flex-row space-between">
              <div>{t('PROFILE.PREV_BAL')}: </div>
              {/* <div>CLP {props.profileData.wallet_moneys && props.profileData.wallet_moneys.wallet_moneys && props.profileData.wallet_moneys.amount.split(' ').join('')}</div> */}
              <div>CLP {CommonService.currency(props.profileData.balances && props.profileData.balances['clp'] && props.profileData.balances['clp'].total)}</div>
            </div>
            <div className="flex-row space-between">
              <div>{t('PROFILE.TRANSFER_AMOUNT')}: </div>
              <div>CLP {CommonService.currency(amount).split(',')[0]}</div>
            </div>
            <hr />
            <div className="flex-row space-between bold-text">
              <div>{t('PROFILE.REMAINING_BAL')}: </div>
              <div>
                CLP{' '}
                {
                  CommonService.currency(
                    props.profileData.balances && props.profileData.balances['clp'] && props.profileData.balances['clp'].total - +amount
                  )
                }
              </div>
            </div>
          </div>
        ) : null}

        {showTransferSuccessBody ? (
          <div className="transfer-money-modal-body font10">
            ¡Listo! El saldo ha sido enviado a la cuenta seleccionada.
            <div></div>
            Te hemos enviado un mensaje de correo electrónico con los detalles de tu transacción.
          </div>
        ) : null}

        {showTransferFailBody ? (
          <div className="transfer-money-modal-body font10">
            Tu transacción no pudo ser realizada. Por favor intenta nuevamente.
            <div></div>
            ¿Necesitas ayuda? ayuda@pasajebus.com +56 9 4915 6683.
          </div>
        ) : null}
      </KuposModalWithButtons>
    </div>
  );
}

export default RechargeWalletKuposPayTransfer;



// WEBPACK FOOTER //
// ./src/features/themes/my-account/RechargeWalletKuposPayTransfer/RechargeWalletKuposPayTransfer.js